import { get_user } from "lib/index";

export default function useAuth() {
  const isAuth = get_user() ? true : false;
  return isAuth;
}
